import { Api as api } from "../../api";
const prefix = "/transport-resource";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    driverDocumentServiceV1UploadDriverDocument: build.mutation<
      DriverDocumentServiceV1UploadDriverDocumentApiResponse,
      DriverDocumentServiceV1UploadDriverDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/api/v1/drivers/documents/upload`,
        method: "POST",
        body: queryArg.apiHttpBody,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as driverDocumentApi };
export type DriverDocumentServiceV1UploadDriverDocumentApiResponse =
  /** status 200 A successful response. */ TransportResourceUploadDriverDocumentRes;
export type DriverDocumentServiceV1UploadDriverDocumentApiArg = {
  /** Message that represents an arbitrary HTTP body. It should only be used for
    payload formats that can't be represented as JSON, such as raw binary or
    an HTML page.


    This message can be used both in streaming and non-streaming API methods in
    the request as well as the response.

    It can be used as a top-level request field, which is convenient if one
    wants to extract parameters from either the URL or HTTP template into the
    request fields and also want access to the raw HTTP body.

    Example:

        message GetResourceRequest {
          // A unique request id.
          string request_id = 1;

          // The raw HTTP body is bound to this field.
          google.api.HttpBody http_body = 2;

        }

        service ResourceService {
          rpc GetResource(GetResourceRequest)
            returns (google.api.HttpBody);
          rpc UpdateResource(google.api.HttpBody)
            returns (google.protobuf.Empty);

        }

    Example with streaming methods:

        service CaldavService {
          rpc GetCalendar(stream google.api.HttpBody)
            returns (stream google.api.HttpBody);
          rpc UpdateCalendar(stream google.api.HttpBody)
            returns (stream google.api.HttpBody);

        }

    Use of this type only changes how the request and response bodies are
    handled, all other features will continue to work unchanged. */
  apiHttpBody: ApiHttpBody;
};
export type TransportResourceUploadDriverDocumentRes = {
  file_url?: string;
  file_name?: string;
  message?: string;
};
export type ProtobufAny = {
  /** Identifies the type of the serialized Protobuf message with a URI reference
    consisting of a prefix ending in a slash and the fully-qualified type name.

    Example: type.googleapis.com/google.protobuf.StringValue

    This string must contain at least one `/` character, and the content after
    the last `/` must be the fully-qualified name of the type in canonical
    form, without a leading dot. Do not write a scheme on these URI references
    so that clients do not attempt to contact them.

    The prefix is arbitrary and Protobuf implementations are expected to
    simply strip off everything up to and including the last `/` to identify
    the type. `type.googleapis.com/` is a common default prefix that some
    legacy implementations require. This prefix does not indicate the origin of
    the type, and URIs containing it are not expected to respond to any
    requests.

    All type URL strings must be legal URI references with the additional
    restriction (for the text format) that the content of the reference
    must consist only of alphanumeric characters, percent-encoded escapes, and
    characters in the following set (not including the outer backticks):
    `/-.~_!$&()*+,;=`. Despite our allowing percent encodings, implementations
    should not unescape them to prevent confusion with existing parsers. For
    example, `type.googleapis.com%2FFoo` should be rejected.

    In the original design of `Any`, the possibility of launching a type
    resolution service at these type URLs was considered but Protobuf never
    implemented one and considers contacting these URLs to be problematic and
    a potential security issue. Do not attempt to contact type URLs. */
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type ApiHttpBody = {
  /** The HTTP Content-Type header value specifying the content type of the body. */
  contentType?: string;
  /** The HTTP request/response body as raw binary. */
  data?: string;
  /** Application specific response metadata. Must be set in the first response
    for streaming APIs. */
  extensions?: ProtobufAny[];
};
export const { useDriverDocumentServiceV1UploadDriverDocumentMutation } =
  injectedRtkApi;
